export const toTitleCaseWithoutQuotes = font => font.replace(/["']/g, '').replace(/\b\w/g, char => char.toUpperCase());
export const formatFontDisplayName = font => toTitleCaseWithoutQuotes(font.split(',')[0]);
//# sourceMappingURL=formatFontDisplayName.js.map